<template>
  <CContainer fluid>
    <CRow alignHorizontal="between">
      <div class="row-card-title left">
        <div>
          <div class="card-title-active">Course Record Overview</div>
          <div class="line" />
        </div>
      </div>
      <div class="row-card-title right">
        <div
          :class="checkClass('overview') + ' button button-icon'"
          @click="goToOverview()"
        >
          Course Overview
        </div>
        <div
          :class="checkClass('exam') + ' button button-icon'"
          @click="goToExamination()"
        >
          Unlock Test
          <img
            src="@/assets/images/admin/Unlock Test.svg"
            style="margin-left: 10px"
            class="icon"
          />
        </div>
        <div
          :class="checkClass('export') + ' button button-icon'"
          @click="goToReportAndExport()"
        >
          Export Report
          <img
            src="@/assets/images/admin/Download.svg"
            style="margin-left: 10px"
            class="icon icon-invert"
          />
        </div>
      </div>
    </CRow>
    <CRow>
      <div class="main-card">
        <CContainer fluid>
          <CRow alignHorizontal="center" class="row-header">
            <h2>{{ courseObject.name[0].val }}</h2>
          </CRow>
          <CRow class="modal-detail">
            <CCol md="4">
              <div style="width: 100%">
                <div class="input-label">Academic Year</div>
                <select
                  style="margin-top: 1rem"
                  class="input input-select"
                  v-model="selectedAcademicYear"
                  @change="onChange($event, 1)"
                >
                  <option>{{ selectedAcademicYear }}</option>
                  <!-- <option v-for="i in 8" :key="i">{{ i + 2562 }}</option> -->
                </select>
              </div>
            </CCol>
            <CCol md="4">
              <div style="width: 100%">
                <div class="input-label">Semester</div>
                <select
                  style="margin-top: 1rem"
                  class="input input-select"
                  v-model="selectedSemester"
                  @change="onChange($event, 2)"
                >
                  <option>{{ selectedSemester }}</option>
                  <!-- <option v-for="i in 3" :key="i">{{ i }}</option> -->
                </select>
              </div>
            </CCol>
            <CCol md="4">
              <div style="width: 100%">
                <div class="input-label">Section</div>
                <select
                  style="margin-top: 1rem"
                  class="input input-select"
                  v-model="selectedSection"
                  @change="onChange($event, 3)"
                >
                  <option v-for="(item, index) in section" :key="index">
                    {{ item.code }}
                  </option>
                </select>
              </div>
            </CCol>
          </CRow>
          <CRow class="modal-detail" style="margin-top: 1.5rem;">
            <CCol md="12">
              <div style="display: flex; gap: 10px; align-items: center; justify-content: flex-start; flex-wrap: wrap;">
                <button 
                  class="btn btn-primary"
                  style="height: calc(1.5em + 0.75rem + 10px); border-radius: 10px; font-weight: bold; white-space: nowrap;"
                  @click="showAddSectionModal = true"
                >
                  + Add Section
                </button>
                <button 
                  class="btn btn-success"
                  style="height: calc(1.5em + 0.75rem + 10px); border-radius: 10px; font-weight: bold; white-space: nowrap; color: white;"
                  @click="showAddTeacherModal = true"
                >
                  + Add Teacher
                </button>
                <button 
                  class="btn btn-info"
                  style="height: calc(1.5em + 0.75rem + 10px); border-radius: 10px; font-weight: bold; white-space: nowrap; color: white;"
                  @click="$refs.excelFileInput.click()"
                >
                  📂 Import Excel
                </button>
                <input 
                  type="file" 
                  ref="excelFileInput" 
                  style="display: none;" 
                  accept=".xlsx, .xls" 
                  @change="handleExcelImport"
                />
              </div>
            </CCol>
          </CRow>
          <CRow alignHorizontal="center" style="margin-top: 3rem">
            <div>
              <!-- Hide OK button since changing dropdown triggers load automatically -->
              <div
                v-if="false && !exportMode"
                class="button button-blue"
                style="width: 150px"
                @click="okBtn()"
              >
                OK
              </div>
              <div
                v-if="!loading && exportMode"
                class="button button-blue"
                style="width: 150px"
                @click="okBtn()"
              >
                Export
              </div>
              <div
                class="spinner-border text-primary"
                role="status"
                v-if="loading && exportMode"
              >
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </CRow>
        </CContainer>
      </div>
    </CRow>

    <!-- Add Section Modal -->
    <CModal
      :show.sync="showAddSectionModal"
      centered
      :closeOnBackdrop="true"
    >
      <template #header>
        <h4 class="modal-title">Create New Section</h4>
      </template>
      <div style="padding: 1.5rem;">
        <p style="color: gray;">Add a new group/section for this course.</p>
        <div class="form-group" style="margin-top: 1.5rem;">
          <label style="font-weight: bold;">Section Code / Name</label>
          <input 
            type="text" 
            class="form-control" 
            placeholder="e.g. testing, 36" 
            v-model="newSectionName"
            style="border-radius: 8px; margin-top: 0.5rem;"
          />
        </div>
      </div>
      <template #footer>
        <button class="btn btn-secondary" style="border-radius: 8px;" @click="showAddSectionModal = false">Cancel</button>
        <button class="btn btn-primary" style="border-radius: 8px; margin-left: 10px;" @click="handleAddSection">Create Section</button>
      </template>
    </CModal>

    <!-- Add Teacher Modal -->
    <CModal
      :show.sync="showAddTeacherModal"
      centered
      :closeOnBackdrop="true"
    >
      <template #header>
        <h4 class="modal-title">Add Instructor to Section</h4>
      </template>
      <div style="padding: 1.5rem;">
        <p style="color: gray;">Enroll a teacher/instructor into a specific section of this course.</p>
        
        <div class="form-group" style="margin-top: 1.5rem;">
          <label style="font-weight: bold;">Instructor ID (Number Only)</label>
          <input 
            type="number" 
            class="form-control" 
            placeholder="e.g. 65371274" 
            v-model="newTeacherId"
            style="border-radius: 8px; margin-top: 0.5rem;"
          />
        </div>

        <div class="form-group" style="margin-top: 1rem;">
          <label style="font-weight: bold;">Instructor Name</label>
          <input 
            type="text" 
            class="form-control" 
            placeholder="e.g. Ajarn Peng Liu" 
            v-model="newTeacherName"
            style="border-radius: 8px; margin-top: 0.5rem;"
          />
        </div>

        <div class="form-group" style="margin-top: 1rem;">
          <label style="font-weight: bold;">Section</label>
          <select 
            class="form-control" 
            v-model="newTeacherSection"
            style="border-radius: 8px; margin-top: 0.5rem;"
          >
            <option v-for="(item, index) in section" :key="index" :value="item.code">
              {{ item.code }}
            </option>
          </select>
        </div>

        <div class="form-group" style="margin-top: 1rem;">
          <label style="font-weight: bold;">Role Type</label>
          <select 
            class="form-control" 
            v-model="newTeacherType"
            style="border-radius: 8px; margin-top: 0.5rem;"
          >
            <option value="TEACHER">TEACHER</option>
            <option value="STUDENT">STUDENT</option>
          </select>
        </div>
      </div>
      <template #footer>
        <button class="btn btn-secondary" style="border-radius: 8px;" @click="showAddTeacherModal = false">Cancel</button>
        <button class="btn btn-success" style="border-radius: 8px; margin-left: 10px; color: white;" @click="handleAddTeacher">Add Instructor</button>
      </template>
    </CModal>

    <!-- Excel Import Preview Modal -->
    <CModal
      :show.sync="showPreviewModal"
      centered
      :closeOnBackdrop="false"
      size="lg"
    >
      <template #header>
        <h4 class="modal-title">Excel Import Preview</h4>
      </template>
      <div style="padding: 1.5rem; max-height: 400px; overflow-y: auto;">
        <h5>1. Sections to Create ({{ previewSections.length }})</h5>
        <div style="display: flex; gap: 8px; flex-wrap: wrap; margin-bottom: 1.5rem; margin-top: 0.5rem;">
          <span 
            v-for="sec in previewSections" 
            :key="sec" 
            class="badge badge-primary" 
            style="font-size: 14px; padding: 6px 12px; border-radius: 6px;"
          >
            {{ sec }}
          </span>
        </div>

        <h5>2. Instructor Enrolments ({{ previewTeachers.length }} records)</h5>
        <table class="table table-bordered table-striped" style="margin-top: 0.5rem;">
          <thead>
            <tr>
              <th>Employee ID</th>
              <th>Name</th>
              <th>Section(s)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(t, index) in previewTeachers" :key="index">
              <td>{{ t.id }}</td>
              <td>{{ t.name }}</td>
              <td>
                <span v-if="t.allSections" class="badge badge-warning" style="color: black; font-weight: bold; font-size: 11px;">All Sections (ขอเห็นทุกตอนเรียน)</span>
                <span v-else class="badge badge-info" style="font-size: 11px;">{{ t.section }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <template #footer>
        <button class="btn btn-secondary" style="border-radius: 8px;" @click="showPreviewModal = false">Cancel</button>
        <button class="btn btn-success" style="border-radius: 8px; margin-left: 10px; color: white;" @click="executeExcelImport">Confirm & Import</button>
      </template>
    </CModal>
  </CContainer>
</template>

<script>
import { mapGetters } from "vuex";
import Service from "../../../../service/api";
import XLSX from "xlsx";

export default {
  name: "courseRecordDetails",
  props: {
    courseObject: Object,
    examMode: Boolean,
    exportMode: Boolean,
    overviewMode: Boolean,
    options: Array,
  },
  data() {
    return {
      disabled: true,
      loading: false,
      selectedSemester: "Loading",
      selectedAcademicYear: "Loading",
      selectedSection: "Loading",
      section: {},
      
      showAddSectionModal: false,
      showAddTeacherModal: false,
      newSectionName: "",
      newTeacherId: "",
      newTeacherName: "",
      newTeacherSection: "",
      newTeacherType: "TEACHER",

      showPreviewModal: false,
      previewSections: [],
      previewTeachers: [],
      finalSectionsPayload: [],
      finalTeachersPayload: [],
    };
  },
  created() {
    const controls = this.courseObject.controls || {};
    this.selectedAcademicYear = controls.academicYear || this.courseObject.academicYear;
    this.selectedSemester = controls.semester || this.courseObject.semester;

    this.section = this.$store.getters["necessary/getInstructorSection"] || [];
    this.sortSections();
    this.selectedSection = this.section[0] ? this.section[0].code : "Loading";
    this.newTeacherSection = this.selectedSection;
  },
  mounted() {},
  computed: {
    ...mapGetters({
      getExportLoading: "courses/getExportLoading",
    }),
  },
  watch: {
    courseObject: {
      handler(newVal) {
        if (newVal) {
          this.section = this.$store.getters["necessary/getInstructorSection"] || [];
          this.sortSections();
          const isExistTesting = this.section.some((item) => item.code == "testing");
          if (isExistTesting) {
            this.selectedSection = "testing";
          } else {
            this.selectedSection = this.section[0] ? this.section[0].code : "Loading";
          }
          const controls = newVal.controls || {};
          this.selectedAcademicYear = controls.academicYear || newVal.academicYear;
          this.selectedSemester = controls.semester || newVal.semester;
        }
      },
      deep: true,
      immediate: true
    },
    getExportLoading: function(val) {
      this.loading = val;
    },
    selectedSection(val) {
      this.newTeacherSection = val;
    },
  },
  methods: {
    sortSections() {
      if (!Array.isArray(this.section)) return;
      this.section = [...this.section].sort((a, b) => {
        const numA = parseInt(a.code, 10);
        const numB = parseInt(b.code, 10);
        if (isNaN(numA) && isNaN(numB)) {
          return String(a.code).localeCompare(String(b.code));
        }
        if (isNaN(numA)) return 1;
        if (isNaN(numB)) return -1;
        return numA - numB;
      });
    },
    checkClass(mode) {
      if (mode == "overview" && this.overviewMode) {
        return "button-blue";
      } else if (mode == "exam" && this.examMode) {
        return "button-blue";
      } else if (mode == "export" && this.exportMode) {
        return "button-blue";
      } else {
        return "button-grey";
      }
    },
    goToExamination() {
      this.section = this.$store.getters["necessary/getInstructorSection"];
      this.selectedSection = this.section[0].code;
      this.selectedAcademicYear = this.courseObject.academicYear;
      this.selectedSemester = this.courseObject.semester;
      this.$emit("returnExamMode");
    },
    goToReportAndExport() {
      this.section = this.$store.getters["necessary/getInstructorSection"];
      this.selectedSection = this.section[0].code;
      this.selectedAcademicYear = this.courseObject.academicYear;
      this.selectedSemester = this.courseObject.semester;
      this.$emit("returnExportMode");
    },
    goToOverview() {
      this.section = this.$store.getters["necessary/getInstructorSection"];
      this.selectedSection = this.section[0].code;
      this.selectedAcademicYear = this.courseObject.academicYear;
      this.selectedSemester = this.courseObject.semester;
      this.$emit("returnOverviewMode");
    },
    okBtn() {
      let payload = {
        academicYear: this.selectedAcademicYear,
        semester: this.selectedSemester,
        section: this.selectedSection,
      };
      this.$emit("returnDataPayload", payload);
    },
    onChange(event, type) {
      if (type == 1) {
        this.selectedAcademicYear = event.target.value;
      } else if (type == 2) {
        this.selectedSemester = event.target.value;
      } else if (type == 3) {
        this.selectedSection = event.target.value;
      }
      this.okBtn(); // Reload data immediately
    },
    async handleAddSection() {
      if (!this.newSectionName) {
        alert("Please enter a section name");
        return;
      }
      try {
        const payload = [
          {
            courseId: this.courseObject.courseId,
            section: this.newSectionName
          }
        ];
        await Service.v3AdminAddSection(payload);
        alert(`Successfully created section: ${this.newSectionName}`);
        
        // Add the new section locally to the select dropdown list immediately
        if (!this.section.some(s => s.code === this.newSectionName)) {
          this.section.push({ code: this.newSectionName, userEnroll: 0, userComplete: 0 });
        }
        this.sortSections();
        this.selectedSection = this.newSectionName;
        this.newSectionName = "";
        this.showAddSectionModal = false;
      } catch (error) {
        console.error("Error creating section:", error);
        alert("Failed to create section. Please try again.");
      }
    },
    async handleAddTeacher() {
      if (!this.newTeacherId || !this.newTeacherName || !this.newTeacherSection) {
        alert("Please fill all required fields");
        return;
      }
      try {
        const payload = [
          {
            id: parseInt(this.newTeacherId, 10),
            name: this.newTeacherName,
            section: this.newTeacherSection,
            type: this.newTeacherType,
            courseId: this.courseObject.courseId
          }
        ];
        await Service.v3AdminAddTeacher(payload);
        alert(`Successfully added ${this.newTeacherName} to section ${this.newTeacherSection}`);
        this.newTeacherId = "";
        this.newTeacherName = "";
        this.showAddTeacherModal = false;
      } catch (error) {
        console.error("Error adding teacher:", error);
        alert("Failed to add teacher. Please try again.");
      }
    },
    async handleExcelImport(event) {
      const file = event.target.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const rows = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
          
          let sectionsToCreate = new Set();
          let teachersToEnroll = [];

          for (let i = 0; i < rows.length; i++) {
            const row = rows[i];
            if (!row || row.length < 2) continue;
            
            const secCell = String(row[0] || '').trim();
            const empCell = String(row[1] || '').trim();

            if (secCell.toLowerCase().includes('section') || empCell.toLowerCase().includes('employee') || empCell.toLowerCase().includes('instructor')) {
              continue;
            }

            if (!secCell || !empCell) continue;
            
            // Split sections by comma
            const sections = secCell.split(',').map(s => s.trim()).filter(Boolean);
            if (sections.length === 0) continue;

            // Extract Employee ID and Name
            const match = empCell.match(/^(\d+)\s+(.+)$/);
            let empId = "";
            let empName = "";
            if (match) {
              empId = match[1];
              empName = match[2].trim();
            } else {
              const digitMatch = empCell.match(/^(\d+)/);
              if (digitMatch) {
                empId = digitMatch[1];
                empName = empCell.replace(empId, "").trim() || empId;
              } else {
                continue;
              }
            }

            // Check if this instructor requests to see all sections
            let allSections = false;
            for (let j = 2; j < row.length; j++) {
              const cellVal = String(row[j] || '').trim();
              if (cellVal.includes('ขอเห็นทุกตอนเรียน') || cellVal.toLowerCase().includes('all section') || cellVal.toLowerCase().includes('all sections')) {
                allSections = true;
                break;
              }
            }

            // Automatically add them to the "testing" section as "STUDENT", so they can test/learn the system
            teachersToEnroll.push({
              id: parseInt(empId, 10),
              name: empName,
              section: "testing",
              type: "STUDENT",
              courseId: this.courseObject.courseId
            });

            if (allSections) {
              teachersToEnroll.push({
                id: parseInt(empId, 10),
                name: empName,
                allSections: true
              });
            } else {
              sections.forEach(sec => {
                teachersToEnroll.push({
                  id: parseInt(empId, 10),
                  name: empName,
                  section: sec,
                  type: "TEACHER",
                  courseId: this.courseObject.courseId
                });
              });
            }

            // Still gather the sections from Column A to create them
            sections.forEach(sec => {
              sectionsToCreate.add(sec);
            });
            // Ensure "testing" section is created
            sectionsToCreate.add("testing");
          }

          if (sectionsToCreate.size === 0) {
            alert("No valid data found in Excel sheet. Please make sure the columns are: 'Section' and 'Employee ID'.");
            return;
          }

          this.previewSections = Array.from(sectionsToCreate);
          this.previewTeachers = teachersToEnroll;

          this.finalSectionsPayload = Array.from(sectionsToCreate).map(sec => ({
            courseId: this.courseObject.courseId,
            section: sec
          }));

          // Resolve instructors who want to see all sections
          let finalTeachers = [];
          let allUniqueSections = new Set([
            ...Array.from(sectionsToCreate),
            ...this.section.map(s => s.code)
          ]);

          teachersToEnroll.forEach(t => {
            if (t.allSections) {
              allUniqueSections.forEach(sec => {
                finalTeachers.push({
                  id: t.id,
                  name: t.name,
                  section: sec,
                  type: "TEACHER",
                  courseId: this.courseObject.courseId
                });
              });
            } else {
              finalTeachers.push(t);
            }
          });
          this.finalTeachersPayload = finalTeachers;
          
          // Open preview modal
          this.showPreviewModal = true;

        } catch (error) {
          console.error("Excel import failed:", error);
          alert("Import failed. Please ensure the Excel format is correct.");
        }
      };
      reader.readAsArrayBuffer(file);
      event.target.value = '';
    },
    async executeExcelImport() {
      this.showPreviewModal = false;
      this.loading = true;
      try {
        // 1. Create sections
        await Service.v3AdminAddSection(this.finalSectionsPayload);
        
        // 2. Add teachers
        await Service.v3AdminAddTeacher(this.finalTeachersPayload);

        // 3. Update dropdown UI
        this.finalSectionsPayload.forEach(p => {
          if (!this.section.some(s => s.code === p.section)) {
            this.section.push({ code: p.section, userEnroll: 0, userComplete: 0 });
          }
        });
        this.sortSections();

        alert(`Import completed successfully!\nCreated ${this.finalSectionsPayload.length} sections\nEnrolled ${this.finalTeachersPayload.length} instructor assignments.`);
      } catch (error) {
        console.error("Excel import failed:", error);
        alert("Import failed. Please ensure the Excel format is correct.");
      } finally {
        this.loading = false;
      }
    }
  },
};
</script>
<style scoped>
.button-grey:hover {
  box-shadow: 2px 2px 8px grey;
}
.button {
  border-radius: 10px !important;
  width: auto !important;
}
</style>
